/**
 * 图片转文本模型类型
 */
export type NoveltySearchPic2TextModelType = 'qwen-2_5' | 'gemini-2.5-flash' | 'qwen-vl-max';

/**
 * 语言类型
 */
export type NoveltySearchPic2TextLanguage = 'CN' | 'EN';

/**
 * 新颖性检索图片转文本请求参数
 */
export interface NoveltySearchPic2TextRequest {
    /**
     * 背景文本，用户输入的背景描述
     */
    background?: string;
    /**
     * 图片公网URL地址列表
     */
    image_url: string[];
    /**
     * 模型类型，可选值：qwen-2_5, gemini-2.5-flash, qwen-vl-max
     * @default 'qwen-vl-max'
     */
    model_type?: NoveltySearchPic2TextModelType;
    /**
     * 语言类型，可选值：CN（中文）、EN（英文）
     */
    language?: NoveltySearchPic2TextLanguage;
}

/**
 * Token使用量统计
 */
export interface NoveltySearchPic2TextUsage {
    /**
     * 提示词token数
     */
    prompt_tokens: number;
    /**
     * 图片token数
     */
    image_tokens: number;
    /**
     * 完成token数
     */
    completion_tokens: number;
    /**
     * 总token数
     */
    total_tokens: number;
}

/**
 * 新颖性检索图片转文本响应数据
 */
export interface NoveltySearchPic2TextResponseData {
    /**
     * 图片描述消息
     */
    message: string;
    /**
     * 角色标识
     */
    role: string;
    /**
     * 使用的模型名称
     */
    model?: string;
    /**
     * Token使用量统计
     */
    usage: NoveltySearchPic2TextUsage;
    /**
     * 完成原因
     */
    finish_reason: string;
}

/**
 * 新颖性检索图片转文本API接口
 * @description 用于将图片转换为文本描述的API接口定义
 */
export const NoveltySearchPic2TextApi = Symbol.for('NoveltySearchPic2TextApi');

/**
 * 新颖性检索图片转文本API接口
 */
export interface NoveltySearchPic2TextApi {
    /**
     * 将图片转换为文本描述
     * @param data 图片转文本请求参数
     * @returns 图片描述结果
     * @description 调用AI模型将图片内容转换为文本描述
     */
    pic2Text(data: NoveltySearchPic2TextRequest): Promise<NoveltySearchPic2TextResponseData>;
}
